module.exports = __webpack_public_path__ + "img/agentos-bw-logo.c526c5a8.png";